import { useEffect, useState } from 'react'

/** Keep notifications visible and operable above a native modal's backdrop. */
export function useToastPortalTarget() {
  const [target, setTarget] = useState<HTMLElement | null>(null)
  useEffect(() => {
    const update = () => {
      const dialogs = document.querySelectorAll<HTMLDialogElement>('dialog[open]')
      setTarget(dialogs.item(dialogs.length - 1) ?? document.body)
    }
    update()
    const observer = new MutationObserver(update)
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    })
    return () => observer.disconnect()
  }, [])
  return target
}
